import { Drawer, Grid2 } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { StandardButton } from "../../../_components/button/primary.button";
import { DrawerHeader } from "../../../_components/drawer/header.drawer";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import { toastr } from "../../../_components/toastr/toastr";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { clientService } from "../../../_services/client.service";
import { IClientManage } from "../../../_common/models/client/clientManage.model";
import { getFormatedDate } from "../../../_helpers/dateTime.helper";
import { DataTypeEnum } from "../../../_common/enum/dataType.enum";
import { DataTypeAutoComplete } from "../../../_components/autocomplete/dataType.autocomplete";

export const ClientCareInfoManageDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void }) => {
    const { clientId } = useParams<{ clientId: string }>();

    const resetData = (): IClientManage => ({
        id: clientId ? Number(clientId) : 0,
        fName: '',
        lName: '',
        centreId: 0,
        nickname: '',
        phone: '',
        dob: '',
        height: null,
        weight: null,
        mobilePhone: '',
        medicalCardNo: '',
        medicalCardExpiry: '',
        allergies: '',
        eyeColourId: null,
        hairColourId: null,
        ethnicOriginId: null,
        careStatusId: null,
        genderId: 0,
        bodyTypeId: null,
        ppsn: '',
        dateOfAdmission: '',
        primaryKeyWorkerId: null,
        secondaryKeyWorkeryId: null,
        lhoAreaId: null,
        email: '',
        complexionId: null,
        caseManagerId: null,
        distinguishingFeatures: '',
        noOfExistingSENs: 0,
        initials: '',
        isActive: true
    });

    const [data, setData] = useState<IClientManage>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
        if (clientId != null)
            fetchData();
        else
            setData(resetData);
    }, [clientId]);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    function fetchData() {
        if (!clientId) return;

        setIsLoading(true);
        return clientService
            .get(clientId)
            .then(
                (json: IClientManage) => {
                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);
        return clientService
            .submit(data)
            .then(
                () => {
                    resetData();
                    params.onSave();
                    toastr.success("Saved successfully");
                }, handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    function cancel() {
        navigate(-1);
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={"Update Care info"} onClose={params.onClose} />

            <ValidatorForm
                onSubmit={submit}
                noValidate>

                <Grid2 container spacing={1} sx={{ "padding": "8px" }}>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="lhoAreaId"
                            label="LHO Area"
                            value={data.lhoAreaId}
                            onChange={handleChange} dataType={DataTypeEnum.LHOAreas} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="careStatusId"
                            label="Care Status"
                            value={data.careStatusId}
                            onChange={handleChange} dataType={DataTypeEnum.CareStatuses} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="centreId"
                            label="Centre"
                            required
                            value={data.centreId}
                            onChange={handleChange} dataType={DataTypeEnum.Centres} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            name="dateOfAdmission"
                            label="Date Of Admission"
                            fullWidth
                            type="date"
                            value={getFormatedDate(data.dateOfAdmission)}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="primaryKeyWorkerId"
                            label="Primary Key Worker"
                            value={data.primaryKeyWorkerId}
                            onChange={handleChange} dataType={DataTypeEnum.Users} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="secondaryKeyWorkeryId"
                            label="Secondary Key Worker"
                            value={data.secondaryKeyWorkeryId}
                            onChange={handleChange} dataType={DataTypeEnum.Users} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="caseManagerId"
                            label="Case Manager"
                            value={data.caseManagerId}
                            onChange={handleChange} dataType={DataTypeEnum.Users} />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: !data.id ? 12 : data?.isActive === false ? 12 : 6 }}>
                                <StandardButton
                                    saving={saving}
                                    loading={isLoading}
                                    icon="save"
                                    type="submit">
                                    {(data?.isActive === false) ? "Save and Reactivate" : "Save"}
                                </StandardButton>
                            </Grid2>

                            {(!!clientId && data?.isActive === true) &&
                                <Grid2 size={{ xs: 6 }}>
                                    <StandardButton
                                        saving={saving}
                                        loading={isLoading}
                                        icon="block"
                                        variant="error"
                                        onClick={cancel}
                                        >
                                        Cancel
                                    </StandardButton>
                                </Grid2>
                            }
                        </Grid2>
                    </Grid2>
                </Grid2>

            </ValidatorForm>
        </Drawer>
    );
};